var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          staticStyle: { "overflow-y": "auto" },
          attrs: {
            title: _vm.title,
            visible: "",
            width: _vm.width ? _vm.width : "",
            "close-on-click-modal": _vm.closeOnClickModal,
            "append-to-body": _vm.appendToBody,
            "show-close": _vm.showClose,
            fullscreen: _vm.fullscreen,
            "destroy-on-close": _vm.destroyOnClose,
            "custom-class": _vm.customClass,
          },
          on: { opened: _vm.open, close: _vm.close },
        },
        [
          _vm.showHeader
            ? _c(
                "div",
                {
                  staticClass: "flex",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("base-icon", {
                    attrs: { "icon-name": "cube2", size: "16" },
                  }),
                  _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
                ],
                1
              )
            : _vm._e(),
          _vm._t("default"),
          _vm.showFooter
            ? _c(
                "footer",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _vm._t("footer"),
                  _vm.showSubmit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v("\n      " + _vm._s(_vm.submitTxt) + "\n    ")]
                      )
                    : _vm._e(),
                  _vm.showClose
                    ? _c(
                        "el-button",
                        { staticClass: "close-btn", on: { click: _vm.close } },
                        [_vm._v("\n      " + _vm._s(_vm.cancelTxt) + "\n    ")]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }